import { NavLink, useLocation } from "react-router-dom";
import {
	CiAlarmOn,
	CiBadgeDollar,
	CiBitcoin,
	CiBullhorn,
	CiChat1,
	CiCircleList,
	CiClock1,
	CiCrop,
	CiDroplet,
	CiGift,
	CiGrid41,
	CiLogout,
	CiMoneyCheck1,
	CiSettings,
	CiStar,
	CiUser,
	CiViewList,
	CiWallet,
} from "react-icons/ci";
import { decodeRolesFromToken } from "../../utilities/helpers";
import { useEffect, useRef, useState } from "react";
import { API_URL, APP_ROLES, DEFAULT_PER_PAGE } from "../../utilities/constants";
import { useUI } from "../../context/ui";
import { useFetch } from "../../hooks/useFetch";
import { IoIosArrowDown } from "react-icons/io";
import { TbMenuDeep, TbX } from "react-icons/tb";
import { MdOutlineAutoAwesome } from "react-icons/md";

const UserCard = () => {
	const { data, error, loading } = useFetch(
		API_URL + "/api/1.0.0/user/profile",
		{
			method: "GET",
		}
	);

	const getRespectiveUI = () => {
		const me = decodeRolesFromToken();
		const myRoleId = me[0];
		const role = APP_ROLES.find(role => role.roleId === myRoleId);
		if (role) {
			return data?.data?.fullName ? `${role.roleId !==1 ? `${data?.data?.fullName} - `:""}${role.titleBeautify}` : role.titleBeautify;
		} else {
			return "Gasolina User"; 
		}
	};

	return (
	<NavLink to="/profile">
		<div className='user-card'>
			<div className='icon flex center-center b-r-100'>
				<CiUser />
			</div>
			{data && (
				<div className='definition flex center-left' style={{ flex: 1 }}>
					<div>
						<p className='l-h-1 color-primary username'>
							<strong>{data?.data.email}</strong>
						</p>
						<p
							className='l-h-1 color-primary'
							style={{ fontSize: "12px" }}>
							{getRespectiveUI()}
						</p>
					</div>
				</div>
			)}
		</div>
	</NavLink>
	);
};


const SubMenu = ({ title, allowedRoles, icon, items }) => {
	const [isOpen, setIsOpen] = useState(false);
	const { pathname } = useLocation();
	const [isAllowed, setIsAllowed] = useState(false);
  
	const hasRole = (sourceArray, targetArray) => {
	  return targetArray.some((value) => sourceArray.includes(value));
	};
  
	const checkIfRoleIdExist = () => {
	  const roles = decodeRolesFromToken();
	  setIsAllowed(hasRole(allowedRoles, roles) ? true : false);
	};
  
	useEffect(() => {
	  checkIfRoleIdExist();
	}, []);
	useEffect(() => {
	  if (items.some((item) => pathname.includes(item.url))) {
		setIsOpen(true);
	  }
	}, [pathname, items]);
  
	if (!isAllowed) {
	  return <></>;
	}
	// check and set active true or false on the basis of the url if in url any of the items url is present then set active true otherwise false
	const isActive = items.some((item) => pathname.includes(item.url));
  
	return (
    <li className={`cursor-pointer ${isActive ? "active" : ""}`}>
      <div
        className={`transition flex center-left submenu`}
        onClick={() => setIsOpen(!isOpen)}
      >
        <span className="flex center-left" style={{ gap: "6px" }}>
          {icon ? icon : <TbMenuDeep />}
          <span
            style={{
              width: "100px",
              display: "inline-block",
              wordWrap: "break-word",
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
            }}
            title={title}
          >
            {title}
          </span>
        </span>

        <span className="flex center-center mar-l-a">
          <IoIosArrowDown
            className={`transition width-auto dis-b  ${
              isOpen ? "arr-open" : ""
            }`}
            size={16}
          />
        </span>
      </div>
      {isOpen && (
        <ul>
          {items.map((item, index) => (
            <MenuItem
              key={index}
              allowedRoles={item.allowedRoles || allowedRoles}
              url={item.url}
              title={item.title}
              icon={item.icon}
              activeUrl={item.activeUrl}
              isSubItem
            />
          ))}
        </ul>
      )}
    </li>
  );
  };
  

const MenuItem = ({ allowedRoles, url, title, icon, activeUrl }) => {
	const { pathname } = useLocation();
	const [isAllowed, setIsAllowed] = useState(false);
	const hasRole = (sourceArray, targetArray) => {
		return targetArray.some((value) => sourceArray.includes(value));
	};

	const checkIfRoleIdExist = () => {
		const roles = decodeRolesFromToken();
		setIsAllowed(hasRole(allowedRoles, roles) ? true : false);
	};

	useEffect(() => {
		checkIfRoleIdExist();
	}, []);

  // const checkIfStringExists = (arr) => {
  // 	if (arr) {
  // 		return arr.includes(pathname.replace(/\/\d+$/, ""));
  // 	} else {
  // 		return false;
  // 	}
  // };
  const checkIfStringExists = (arr) => {
    if (!arr) return false;

    return arr.some((pattern) => {
      if (pattern.endsWith("*")) {
        const basePath = pattern.slice(0, -1);
        return pathname.startsWith(basePath);
      } else if (pattern.includes("/:")) {
        const patternParts = pattern.split("/:")[0];
        return pathname.startsWith(patternParts);
      } else {
        return pathname.replace(/\/\d+$/, "") === pattern;
      }
    });
  };

  if (!isAllowed) {
    return <></>;
  } else {
    return (
      <li
        className={
          pathname === url || checkIfStringExists(activeUrl) ? "active" : ""
        }
        onClick={() => {
          const menu = document.getElementById("menu");
          menu.classList.remove("active");
        }}
      >
        <NavLink to={url}>
          <span
            style={{
              height: "20px",
              width: "20px",
            }}
            className="flex center-center"
          >
            {icon}
          </span>
          <span>{title}</span>
        </NavLink>
      </li>
    );
  }
};

const Aside = () => {
  const { setShowLogout } = useUI();
  const menuref = useRef(null);
  const [isOpen, setIsOpen] = useState(false);
  useEffect(() => {
    const menu = document.getElementById("menu");
    const observer = new MutationObserver(() => {
      setIsOpen(menu.classList.contains("active"));
    });

    observer.observe(menu, { attributes: true, attributeFilter: ["class"] });
    return () => observer.disconnect();
  }, [document.getElementById("menu")]);

  const toggleMenu = () => {
    const menu = document.getElementById("menu");
    menu.classList.toggle("active");
  };
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (menuref.current && !menuref.current.contains(event.target)) {
        const menu = document.getElementById("menu");
        menu.classList.remove("active");
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);
  return (
    <aside ref={menuref}>
      <div className="top">
        <div className="logo">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="123.376"
            height="25"
            viewBox="0 0 123.376 25"
          >
            <g transform="translate(57.776 22)">
              <path
                d="M-35.786-7.916h6.839a2.423,2.423,0,0,1,.026.287q.005.154.005.472a7.746,7.746,0,0,1-1.928,5.465A6.468,6.468,0,0,1-35.827.4,7.874,7.874,0,0,1-41.59-1.83,7.611,7.611,0,0,1-43.856-7.5a7.539,7.539,0,0,1,2.276-5.629,7.893,7.893,0,0,1,5.752-2.225,7.373,7.373,0,0,1,3.363.769,8.12,8.12,0,0,1,2.728,2.3l-2.164,1.6a5.264,5.264,0,0,0-1.7-1.451,4.55,4.55,0,0,0-2.061-.446A4.711,4.711,0,0,0-39.221-11.2a5.112,5.112,0,0,0-1.333,3.7A5.1,5.1,0,0,0-39.216-3.82a4.611,4.611,0,0,0,3.491,1.4,4.142,4.142,0,0,0,2.563-.743,2.323,2.323,0,0,0,.984-1.943v-.164h-3.609Zm16.57,2.871A3.168,3.168,0,0,0-19.9-7.188a2.307,2.307,0,0,0-1.841-.79,2.35,2.35,0,0,0-1.871.784,3.164,3.164,0,0,0-.682,2.148,3.1,3.1,0,0,0,.672,2.123,2.356,2.356,0,0,0,1.861.759,2.365,2.365,0,0,0,1.876-.759A3.11,3.11,0,0,0-19.216-5.045ZM-16.55,0h-2.83l.041-1.446a3.828,3.828,0,0,1-1.43,1.4A4.275,4.275,0,0,1-22.8.4,3.975,3.975,0,0,1-26.03-1.087a5.979,5.979,0,0,1-1.225-3.927,5.943,5.943,0,0,1,1.2-3.963A4.154,4.154,0,0,1-22.7-10.4a3.772,3.772,0,0,1,1.964.5,4.033,4.033,0,0,1,1.42,1.5v-1.661h2.769Zm1.764-1.764,2.246-1.159a1.4,1.4,0,0,0,.6.923,2.1,2.1,0,0,0,1.22.338,2.087,2.087,0,0,0,1.128-.261.815.815,0,0,0,.41-.723q0-.728-1.456-1.22-.451-.154-.718-.256a7.207,7.207,0,0,1-2.456-1.343,2.262,2.262,0,0,1-.682-1.671A2.9,2.9,0,0,1-13.33-9.526a4.8,4.8,0,0,1,3.056-.913A4.8,4.8,0,0,1-7.931-9.9,3.254,3.254,0,0,1-6.491-8.357L-8.634-7.291a1.545,1.545,0,0,0-.6-.856,1.875,1.875,0,0,0-1.077-.292,1.854,1.854,0,0,0-1.046.267.807.807,0,0,0-.4.7q0,.749,1.989,1.395.236.072.359.113A5.791,5.791,0,0,1-7.065-4.7a2.543,2.543,0,0,1,.7,1.841A2.834,2.834,0,0,1-7.526-.482,5.042,5.042,0,0,1-10.654.4a5.655,5.655,0,0,1-2.661-.579A2.926,2.926,0,0,1-14.786-1.764Zm18.17-3.25a2.686,2.686,0,0,0-.718-1.964A2.575,2.575,0,0,0,.738-7.711a2.55,2.55,0,0,0-1.917.728,2.7,2.7,0,0,0-.708,1.969,2.726,2.726,0,0,0,.708,1.969,2.531,2.531,0,0,0,1.917.738,2.569,2.569,0,0,0,1.923-.738A2.693,2.693,0,0,0,3.384-5.014Zm2.974.021A5.151,5.151,0,0,1,4.773-1.138,5.527,5.527,0,0,1,.759.4a5.572,5.572,0,0,1-4.04-1.538A5.143,5.143,0,0,1-4.871-4.994a5.147,5.147,0,0,1,1.6-3.855A5.56,5.56,0,0,1,.759-10.4,5.544,5.544,0,0,1,4.778-8.87,5.163,5.163,0,0,1,6.357-4.994ZM8.675,0V-15.894h2.912V0Zm5.732-14.191a1.638,1.638,0,0,1,.5-1.2,1.638,1.638,0,0,1,1.2-.5,1.675,1.675,0,0,1,1.215.5,1.624,1.624,0,0,1,.508,1.2,1.641,1.641,0,0,1-.508,1.21,1.666,1.666,0,0,1-1.215.5,1.621,1.621,0,0,1-1.2-.513A1.66,1.66,0,0,1,14.407-14.191ZM14.663,0V-10.059h2.912V0Zm5.875,0V-10.059H23.4V-8.48a5.344,5.344,0,0,1,1.7-1.451,4.341,4.341,0,0,1,2.015-.467A4.388,4.388,0,0,1,29.075-10a2.922,2.922,0,0,1,1.256,1.2,3.234,3.234,0,0,1,.323.948,10.072,10.072,0,0,1,.1,1.656V0H27.829V-4.973A4.643,4.643,0,0,0,27.4-7.424a1.7,1.7,0,0,0-1.477-.595,2.473,2.473,0,0,0-1.113.251,2.3,2.3,0,0,0-.846.713,2.325,2.325,0,0,0-.385.82,6.142,6.142,0,0,0-.118,1.4V0Zm20.4-5.045a3.168,3.168,0,0,0-.682-2.143,2.307,2.307,0,0,0-1.841-.79,2.35,2.35,0,0,0-1.871.784,3.164,3.164,0,0,0-.682,2.148,3.1,3.1,0,0,0,.672,2.123,2.356,2.356,0,0,0,1.861.759,2.365,2.365,0,0,0,1.876-.759A3.11,3.11,0,0,0,40.934-5.045ZM43.6,0H40.77l.041-1.446a3.828,3.828,0,0,1-1.43,1.4A4.275,4.275,0,0,1,37.345.4,3.975,3.975,0,0,1,34.12-1.087a5.979,5.979,0,0,1-1.225-3.927,5.943,5.943,0,0,1,1.2-3.963,4.154,4.154,0,0,1,3.348-1.42,3.772,3.772,0,0,1,1.964.5,4.033,4.033,0,0,1,1.42,1.5v-1.661H43.6Z"
                transform="translate(22 -2)"
                fill="#2980B9"
              />
              <path
                d="M0,0H2V12H0Z"
                transform="translate(-33 -15)"
                fill="#e3e3e3"
              />
              <path
                id="iconmonstr-drop-5"
                d="M6.706,8.687,15.489,4.7q.864,1.316,1.6,2.515L4.745,12.822A25.7,25.7,0,0,1,6.706,8.687ZM4.1,15.4A9.923,9.923,0,0,0,4,16.745a8.169,8.169,0,0,0,.217,1.847l15.255-6.932A28.781,28.781,0,0,0,18.15,9.017L4.1,15.4Zm2.731,7.532,13.834-6.288a11.148,11.148,0,0,0-.48-3.024L4.942,20.55A8.26,8.26,0,0,0,6.832,22.934Zm7.488-20C13.694,2.006,13.033,1.032,12.335,0,10.964,2.028,9.728,3.845,8.65,5.516Zm-5.4,21.333a8.356,8.356,0,0,0,11.4-5.18l-11.4,5.18Z"
                transform="translate(-61.776 -22)"
                fill="#2980B9"
              />
            </g>
          </svg>
        </div>
        <div className="flex" style={{ gap: "10px" }}>
          <UserCard />
          <div
            className="menu-btn flex center-center"
            style={{
              transform: isOpen ? "rotate(180deg)" : "rotate(0deg)",
              transition: "transform 0.9s ease-in-out",
            }}
            onClick={toggleMenu}
          >
            {isOpen ? (
              <TbX size={20} color="#2980B9" />
            ) : (
              <TbMenuDeep size={20} color="#2980B9" />
            )}
          </div>
        </div>
      </div>
      <div className="middle" id="menu">
        <nav>
          <ul>
            {/*<SubMenu
							allowedRoles={[1]}
							title="Customer Management"
							icon={<CiViewList />}
							items={[
								{
								url: "/marketing",
								title: "Notifications",
								icon: <CiAlarmOn />,
								activeUrl: ["/marketing"],
								},
								{
								url: "/wallet",
								title: "Campaigns",
								icon: <CiBullhorn />,
								activeUrl: ["/wallet"],
								},
							]}
						/>*/}
						{/* =================== RoleId: 1 ================== */}
						<MenuItem
							allowedRoles={[1, 2, 3, 6, 8, 9, 10]}
							url='/dashboard'
							title='Dashboard'
							icon={<CiGrid41 />}
						/>
						<MenuItem
							allowedRoles={[1,2]}
							url={`/client?pageNo=0&pageSize=${DEFAULT_PER_PAGE}`}
							activeUrl={["/client", "/client/add"]}
							title='Client'
							icon={<CiCrop />}
						/>
						<MenuItem
							allowedRoles={[1, 2, 6, 8]}
							url={`/sites?pageNo=0&pageSize=${DEFAULT_PER_PAGE}`}
							activeUrl={["/sites", "/sites/add"]}
							title='Sites'
							icon={<CiDroplet />}
						/>
						<MenuItem
							allowedRoles={[1, 2, 6, 8]}
							url={`/users?pageNo=0&pageSize=${DEFAULT_PER_PAGE}`}
							activeUrl={[`/users`, "/users/add"]}
							title='Users'
							icon={<CiUser />}
						/>

						<MenuItem
							allowedRoles={[1, 9]}
							url='/wallet'
							title='Wallet'
							icon={<CiWallet />}
						/>
						 <MenuItem
							allowedRoles={[1]}
							url={`/customers?pageNo=0&pageSize=${DEFAULT_PER_PAGE}`}
							activeUrl={["/customers","/customers/notification"]}
							title='Customers'
							icon={<CiViewList />}
						/>
						 <MenuItem
							allowedRoles={[1]}
							url={`/marketing`}
							activeUrl={["/notification","/marketing/notification"]}
							title='Marketing'
							icon={<CiBullhorn />}
						/>
						<MenuItem
							allowedRoles={[1, 2, 3, 6, 7, 8, 9, 10]}
							url={`/transactions?pageNo=0&pageSize=${DEFAULT_PER_PAGE}`}
							activeUrl={["/transactions"]}
							title='Transactions'
							icon={<CiClock1 />}
						/>
						<MenuItem
							allowedRoles={[ 4]}
							url={`/transactions`}
							activeUrl={["/transactions"]}
							title='Transactions'
							icon={<CiClock1 />}
						/>
						<MenuItem
							allowedRoles={[4]}
							url='/agent-referral'
							activeUrl={["/agent-referral"]}
							title='My Referrals'
							icon={<CiStar />}
						/>
						<MenuItem
							allowedRoles={[10]}
							url={`/site-config`}
							activeUrl={["/site-config"]}
							title='Site Config'
							icon={<CiSettings />}
						/>
						<MenuItem
							allowedRoles={[1,9, 6, 8, 3]}
							url={`/unsettled`}
							activeUrl={["/unsettled"]}
							title='Unsettled Txn'
							icon={<CiMoneyCheck1 />}
						/>
						<MenuItem
							allowedRoles={[ 9]}
							url={`/settlement?pageNo=0&pageSize=${DEFAULT_PER_PAGE}`}
							activeUrl={["/settlement"]}
							title="Txn Settlement"//'Transaction Settlement'
							icon={<CiBadgeDollar />}
						/>
						<MenuItem
							allowedRoles={[9]}
							url={`/re-settlement?pageNo=0&pageSize=${DEFAULT_PER_PAGE}`}
							activeUrl={["/re-settlement"]}
							title="Re Settlement"//'Transaction Settlement'
							icon={<CiGift />}
						/>
						<MenuItem
							allowedRoles={[1, 9 , 2 ,6 ,8 ,3 ]}
							url={`/settlement-history?pageNo=0&pageSize=10`}
							activeUrl={["/settlement-history","/settlements-txn"]}
							title='Settlements'//'Settlement History'
							icon={<CiCircleList />}
						/>
						<MenuItem
							allowedRoles={[1, 9 , 2]}
							url={`/reconciliation-report`}
							activeUrl={["/reconciliation-report"]}
							title='Reconciliation'//Report'
							icon={<CiCircleList />}
						/>
						<MenuItem
							allowedRoles={[1]}
						    url={`/feedback?pageNo=0&pageSize=10`}
							activeUrl={["/feedback"]}
							title='Feedback'
							icon={<CiChat1/>}
						/>
						<MenuItem
							allowedRoles={[1, 2, 9]}
							url={`/referral-program`}
							activeUrl={["/referral-program"]}
							title='Referrals'
							icon={<CiStar />}
						/>
						<MenuItem	
							allowedRoles={[1,9]}
							url='/rewards'
							activeUrl={["/rewards/customers","/rewards","/rewards/customer/:id"]}
							title='Rewards'
							icon={<CiBitcoin />}
						/>
						<MenuItem
							allowedRoles={[1, 2, 3, 4, 6, 7, 8, 9 ,10]}
							url='/profile'
							title='Profile'
							icon={<CiUser />}
						/>
					</ul>
				</nav>
			</div>
			<div className='bottom'>
				<div className='logout' onClick={() => setShowLogout(true)}>
					<p className='l-h-1-2 color-primary'>Log out</p>
					<CiLogout />
				</div>
				<div className='version'>
					<p className='l-h-1-2'>www.gasolina.com</p>
				</div>
			</div>
		</aside>
	);
};

export default Aside;
